import { PrivacyTip as DatenschutzIcon, Dashboard as DashboardIcon } from '@mui/icons-material';
import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { DcbApp } from '../../components/dcbApp/DcbApp';
import { AppFeature } from '../../components/dcbApp/types';
import logo from '../../logo.svg';
import { aufwandFeature } from '../aufwand/aufwandFeature';
import { useMitarbeiterRole } from '../auth/api/auth.hook';
import { MitarbeiterRole } from '../auth/api/types';
import { Dashboard } from '../dashboard/Dashboard';
import { DatenschutzContainer } from '../datenschutz/DatenschutzContainer';
import { DatenschutzDialogForm } from '../datenschutz/DatenschutzDialogForm';
import { interessentFeature } from '../interessent/interessentFeature';
import { kundeFeature } from '../kunde/kundeFeature';
import { mitarbeiterFeature } from '../mitarbeiter/mitarbeiterFeature';
import { projektFeature } from '../projekt/projektFeature';

export const features: AppFeature[] = [
  {
    path: 'dashboard',
    label: 'Dashboard',
    icon: <DashboardIcon sx={{ color: 'secondary.main' }} />,
    view: <Dashboard />,
  },
  aufwandFeature,
  projektFeature,
  kundeFeature,
  interessentFeature,
  mitarbeiterFeature,
  {
    path: 'datenschutzhinweise',
    label: 'Datenschutzhinweise',
    icon: <DatenschutzIcon sx={{ color: 'secondary.main' }} />,
    view: <DatenschutzContainer />,
    dialogs: [<DatenschutzDialogForm key="datenschutz-dialog" />],
  },
];

const useGuardInternApp = () => {
  const navigate = useNavigate();
  const role = useMitarbeiterRole();

  useEffect(() => {
    if (role === MitarbeiterRole.EXTERN) {
      navigate('/extern');
    }
  });
};

export const InternApp: FC<{ hasAccessToken: boolean }> = ({ hasAccessToken }) => {
  useGuardInternApp();
  return (
    <DcbApp
      loggedIn={hasAccessToken}
      logo={<img src={logo} alt="Logo" style={{ height: '42px' }} />}
      features={features}
    />
  );
};
